/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementViewEventResponse } from './EventManagementViewEventResponse';

export type EventManagementViewEventResponseApiRespoonse = {
    data?: EventManagementViewEventResponse;
    status?: EventManagementViewEventResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementViewEventResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

